import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MerchandisingProductViewModel } from '@shared/models/merchandising-product-view.model';
import {
  selectMerchandisingMultipleExperiencesProductNumbers,
  selectMerchandisingProductNumbers,
  selectMerchandisingViewModel,
} from '@shared/selectors/merchandising.selectors';
import {
  MerchandisingActions,
  isMerchandisingStateReady,
} from '@usf/ngrx-product';
import { MerchandisingRequest } from '@usf/product-types';
import { Observable, filter, first, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MerchandisingService {
  constructor(private store: Store) {}

  fetchMerchandising(request: MerchandisingRequest): Observable<boolean> {
    return this.store.select(isMerchandisingStateReady).pipe(
      first(isReady => {
        return isReady;
      }),
      map(isReady => {
        this.store.dispatch(
          MerchandisingActions.FetchMerchandisingResult({
            request,
          }),
        );
        return isReady;
      }),
    );
  }

  loadMerchandisingProducts$(
    experience: string,
  ): Observable<MerchandisingProductViewModel[]> {
    return this.store.select(selectMerchandisingViewModel(experience)).pipe(
      filter(products => {
        if (products?.length === 0) return false;
        return products?.every(
          val =>
            !!val.summary && !!val.pricing && val.pricing.loading === false,
        );
      }),
      take(1),
    );
  }

  getMerchandisingProductNumbers$(experience: string): Observable<number[]> {
    return this.store.select(selectMerchandisingProductNumbers(experience));
  }

  getMerchandisingMultipleExperiencesProductNumbers$(
    experiences,
  ): Observable<number[][]> {
    return this.store.select(
      selectMerchandisingMultipleExperiencesProductNumbers(experiences),
    );
  }
}
